/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gallery_Demote_ConfirmInputs */

const cs_gallery_demote_confirm = /** @type {(inputs: Gallery_Demote_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odebrat tuto fotku z publikované galerie? Portály a web ji přestanou používat.`)
};

const en_gallery_demote_confirm = /** @type {(inputs: Gallery_Demote_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove this photo from the published gallery? Portals and the website will stop using it.`)
};

/**
* | output |
* | --- |
* | "Remove this photo from the published gallery? Portals and the website will stop using it." |
*
* @param {Gallery_Demote_ConfirmInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gallery_demote_confirm = /** @type {((inputs?: Gallery_Demote_ConfirmInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallery_Demote_ConfirmInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gallery_demote_confirm(inputs)
	return cs_gallery_demote_confirm(inputs)
});